'use strict';

export default class ParagraphTypePartnerCarousel {
    constructor() {
        this.name = 'paragraph--type--partner-carousel';
        // Drupal.behaviors.myCarouselBehavior = {
        //     attach: function (context, settings) {
        //         once('myCarouselBehavior', 'html').forEach(function (element) {
        //             console.log("I am running inside myCarouselBehavior");
        //             $(".field--name-field-partner").slick({
        //                 infinite: true,
        //                 variableWidth: true,
        //                 centerMode: true,
        //                 dots: false,
        //                 autoplay: true,
        //                 row: 2,
        //                 slidesPerRow: 4,
        //                 autoplaySpeed: 0,
        //                 speed: 9000,
        //                 arrows: false,
        //                 cssEase: 'linear',
        //                 slidesToScroll: 1,
        //                 pauseOnHover: false,
        //                 swipeToSlide: true,
        //             });
        //         })
        //     }
        // }
        if ($(".field--name-field-partner .field__item").length > 0) {
            $(".field--name-field-partner").slick({
                infinite: true,
                variableWidth: true,
                centerMode: true,
                dots: false,
                autoplay: true,
                row: 2,
                slidesPerRow: 4,
                autoplaySpeed: 0,
                speed: 9000,
                arrows: false,
                cssEase: 'linear',
                slidesToScroll: 1,
                pauseOnHover: false,
                swipeToSlide: true,
            });
        }

        if ($(".footer-marquee-block").length > 0) {

            // Drupal.behaviors.myOtherCarouselBehavior = {
            //     attach: function (context, settings) {
            //       once('myOtherCarouselBehavior', 'html').forEach(function (element) {
            //         $(".footer-marquee-block ul").slick({
            //             infinite: true,
            //             variableWidth: true,
            //             centerMode: true,
            //             dots: false,
            //             autoplay: true,
            //             autoplaySpeed: 0,
            //             speed: 7000,
            //             arrows: false,
            //             cssEase: 'linear',
            //             slidesToScroll: 1,
            //         });
            //       })
            //     }
            //   }
            $(".footer-marquee-block ul").slick({
                infinite: true,
                variableWidth: true,
                centerMode: true,
                dots: false,
                autoplay: true,
                autoplaySpeed: 0,
                speed: 7000,
                arrows: false,
                cssEase: 'linear',
                slidesToScroll: 1,
            });

        }
    }
}
